import { render, staticRenderFns } from "./crudSurrenderSeller.vue?vue&type=template&id=81b6fe52&scoped=true&"
import script from "./crudSurrenderSeller.vue?vue&type=script&lang=js&"
export * from "./crudSurrenderSeller.vue?vue&type=script&lang=js&"
import style0 from "./crudSurrenderSeller.vue?vue&type=style&index=0&lang=css&"
import style1 from "./crudSurrenderSeller.vue?vue&type=style&index=1&id=81b6fe52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b6fe52",
  null
  
)

export default component.exports